import React from 'react';
import {Provider} from 'react-redux';
import {ConnectedRouter} from 'connected-react-router';
import { ToastContainer } from 'react-toastify';
import configureStore, { history } from './store';
import MainRoutes from './routing';
import './App.scss'

const store = configureStore()

export default function App() {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <MainRoutes />
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </ConnectedRouter>
    </Provider>
  );
}

